<template>
  <v-menu :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <px-cancelamento-cotacao-button v-if="!isRascunho"
                                      show-list-item
                                      :show-tootip="false"
                                      :disabled="!isAberta"
                                      :cotacao="cotacao"
                                      @cancelada="onClickCancel"
                                       />
      <v-list-item v-if="!isRascunho" :disabled="!isAberta" @click="goToEditCotacao(cotacao)">
        <v-list-item-icon>
          <v-icon>mdi-pencil</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Editar cotação</v-list-item-content>
      </v-list-item>
      <v-list-item v-if="isRascunho"
                  @click="goToEditCotacaoRascunho(cotacao)">
        <v-list-item-icon>
          <v-icon>mdi-pencil</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Editar rascunho
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="!isRascunho" @click="goToCopy">
        <v-list-item-icon>
          <v-icon>mdi-content-copy</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Copiar cotação</v-list-item-content>
      </v-list-item>
      <v-list-item v-if="isRascunho" @click="onClickRemove(cotacao)">
        <v-list-item-icon>
          <v-icon>mdi-delete</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Remover rascunho
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <px-confirm-dialog ref="confirm"/>
  </v-menu>
</template>

<script>
import { SituacaoCotacao } from 'px-business-components';
import CancelamentoCotacaoButton from '@/modules/cotacao/movimentacao/CancelamentoCotacaoButton.vue';

export default {
  props: {
    cotacao: Object,
  },
  computed: {
    isAberta() {
      return SituacaoCotacao.keys.ABERTA.key === this.cotacao.situacao;
    },
    isRascunho() {
      return SituacaoCotacao.keys.RASCUNHO.key === this.cotacao.situacao;
    },
  },
  methods: {
    goToCopy() {
      this.$router.push({
        name: 'main.cotacoes.cadastro',
        params: {
          id: this.cotacao.id,
          isRascunho: false,
          isCopy: true,
        },
      });
    },
    goToEditCotacao(cotacao) {
      this.$router.push({
        name: 'main.cotacoes.edicao-parcial',
        params: {
          id: cotacao.id,
        },
      });
    },
    goToEditCotacaoRascunho(cotacao) {
      this.$router.push({
        name: 'main.cotacoes.edicao',
        params: {
          id: cotacao.id,
          isRascunho: true,
          isCopy: false,
        },
      });
    },
    remove(cotacao) {
      this.$emit('remove', cotacao);
    },
    onClickRemove(cotacao) {
      this.$refs.confirm.open('Você deseja remover este rascunho?',
        'A cotação será removida e esta operação não pode ser desfeita.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(cotacao);
        });
    },
    emitUpdate() {
      this.$emit('update');
    },
    onClickCancel() {
      this.emitUpdate();
    },
    onUpdate() {
      this.emitUpdate();
    },
  },
  components: {
    pxCancelamentoCotacaoButton: CancelamentoCotacaoButton,
  },
};
</script>
